angular.module('signalflowv2').service('programAnalyzer', [
    '$window',
    function ($window) {
        return $window.signalfx.signalflowutils.analyzer;
    },
]);
